export default __webpack_public_path__ + "c13.png";